import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../../../service/udnick';
import { IAgendamentos } from 'store/ducks/agendamentos/types';

export interface ListaMotivo {
  cod: string;
  descricao: string;
}

export const AgendamentoServices = {
  getAllData: (
    codCdd: number | undefined,
    filtro: any,
    parceiros: number[],
    tamanhoPagina: number | undefined
  ): Promise<AxiosResponse<{agendamentos:IAgendamentos[]}>> =>
    UDNICK.callService(
      'getAgendamentos',
      {
        codCdd,
        filtro,
        parceiros,
      },
      {
        tamanhoPagina,
      }
    ),

  getPedidosOrdemCarga: (
    ordemCarga: any,
    centroDistribuicao: any,
    parceiros: string
  ): Promise<AxiosResponse> =>
    UDNICK.callService('getPedidosOrdemCarga', {
      ordemCarga,
      codEmp: centroDistribuicao,
      parceiros,
    }),

  listaMotivosCanAge: (): Promise<AxiosResponse<{ motivos: ListaMotivo[] }>> =>
    UDNICK.callService('listaMotivosCanAge'),
};
